/** Mirrors ↻ visibility: user-assigned tier differs from the stored original/default tier. */
export function hasMovedFromOriginalTier<T>(originalTier: T | undefined, currentTier: T): boolean {
  return originalTier !== undefined && originalTier !== currentTier;
}
